import { AccordionList, AccordionListContainer } from 'twyne-new.ui'

import { useStoreLayouts, useStorePartials, useStoreTemplates } from '@/modules/cms/views/post/components/builder/context'

import BlockList from './BlockList'

export default function Blocks() {
  const templates = useStoreTemplates()
  const layouts = useStoreLayouts()
  const partials = useStorePartials()

  return <>
    <AccordionListContainer>
      <AccordionList type='single' defaultValue={'layouts'}>
        <BlockList store={layouts} title='layouts' />
        <BlockList store={partials} title='partials' />
        <BlockList store={templates} title='templates' />
      </AccordionList>
    </AccordionListContainer>
  </>
}
